import { useDarkModeSettings } from "../hooks/useDarkModeSettings";
import DarkModeToggle from "./DarkModeToggleMenuButton";

export default function DarkModeMenuButton() {
  const { darkModeEnabled, toggleDarkMode } = useDarkModeSettings();

  return <DarkModeToggle isEnabled={darkModeEnabled} toggle={toggleDarkMode} />;
}
